import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

const PaymentFaq = () => {
  const items = [
    {
      id: 'a',
      btnText: 'Direct Bank Transfer',
      description:
        'Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order won’t be shipped until the funds have cleared in our account.',
    },
    {
      id: 'b',
      btnText: 'Cheque Payment',
      description:
        'Please send your cheque to Store Name, Store Street, Store Town, Store State / Country, Store Postcode.',
    },
    {
      id: 'c',
      btnText: 'PayPal',
      description:
        'Pay via PayPal; you can pay with your credit card if you don’t have a PayPal account.',
    },
  ];

  return (
    <Accordion className="accordion" preExpanded={['a']} allowZeroExpanded>
      {items.map((item) => (
        <AccordionItem key={item.id} className="accordion-item" uuid={item.id}>
          <AccordionItemHeading className="accordion-header">
            <AccordionItemButton className="accordion-button shadow-none">
              {item.btnText}
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel>
            <div className="accordion-body">{item.description}</div>
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default PaymentFaq;
